import fetcher from 'api/fetcher';
import axios, { AxiosError, Canceler } from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import type { BidRating } from 'store/models/auctionData';
import { AuctionBuilderErrors, auctionSelectorNonNullable, setBidRating, setErrors } from 'store/models/auctionData';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

let cancelPreviousRequest: Canceler | undefined;

export const fetchBidRating = (setLoading: (loading: boolean) => void, abortSignal: AbortSignal): AppThunkAction => {
    return (dispatch, getState) => {
        const state = getState();
        const { value: bid } = auctionSelectorNonNullable.bid(state);
        const bidRatingParams = auctionSelectorNonNullable.bidRatingParams(state);

        cancelPreviousRequest?.();
        const source = axios.CancelToken.source();
        cancelPreviousRequest = source.cancel;

        setLoading(true);
        const query = urlParser.stringify({
            bid,
            ...bidRatingParams,
            areaIds: bidRatingParams.areaIds?.map(String),
            professionalRoleIds: bidRatingParams.professionalRoleIds?.map(String),
        });
        return fetcher
            .get<unknown, BidRating>(`/api/v1/auction/bid_rating?${query}`, {
                cancelToken: source.token,
                signal: abortSignal,
            })
            .then((bidRating) => {
                dispatch(setBidRating(bidRating));
            })
            .catch((error: AxiosError<AuctionBuilderErrors>) => {
                if (axios.isCancel(error) || abortSignal?.aborted) {
                    return;
                }
                if (error?.response?.status === 400) {
                    const errors = error.response.data;
                    dispatch(setErrors(errors));
                } else {
                    dispatch(addMagritteNotification(MagritteNotificationName.AuctionBuilderSomethingWentWrongError));
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 100);
            });
    };
};
